import React from 'react';

import { prepareSearchUrl } from '../utils';

type EntityInfoBoxLinkItemProps = {
    label: string;
    url: string;
    openInNewTab: boolean;
    encryptionDetails: EncryptionDetailsType;
    dataType: string;
};
export default function WikiBoxInfoBoxLinkItem({
    label,
    url,
    openInNewTab,
    encryptionDetails,
    dataType,
}): React.ReactElement<EntityInfoBoxLinkItemProps> {
    return (
        <a
            datatype={dataType || undefined}
            href={prepareSearchUrl(label, url, encryptionDetails)}
            target={openInNewTab ? '_blank' : ''}
            rel="noopener noreferrer"
            className="wikiBox__value-link"
        >
            {label}
        </a>
    );
}
